import { CreditCardHelper } from "Helpers/CreditCardHelper"
import VisaIcon from '../Assets/VisaIcon.svg'
import MastercardIcon from '../Assets/MastercardIcon.svg'
import AmericanExpressIcon from '../Assets/AmericanExpressIconCard.svg'
import JcbIcon from '../Assets/JCBIcon.svg'
import { Stack } from "@mui/material"

const BrandOfCard = (cardBrand) => {
    const checkCreditcard = CreditCardHelper.checkCardType(cardBrand, false)

    switch (checkCreditcard.toUpperCase()) {
        case 'VISA':
            return <img src={VisaIcon} alt="VisaIcon" />
        case 'MASTERCARD':
            return <img src={MastercardIcon} alt="MastercardIcon" />
        case 'AMERICAN-EXPRESS':
            return <img src={AmericanExpressIcon} alt="AmericanExpressIcon" />
        case 'JCB':
            return <img src={JcbIcon} alt="JcbIcon" width={'25px'} height={'16px'} />
        case 'ALL':
            return (
                <Stack direction={'row'} gap={'8px'}>
                    <img src={VisaIcon} alt="VisaIcon" />
                    <img src={MastercardIcon} alt="MastercardIcon" />
                    <img src={AmericanExpressIcon} alt="AmericanExpressIcon" />
                    <img src={JcbIcon} alt="JcbIcon" width={'25px'} height={'16px'} />
                </Stack>
            )
        default:
            return null
    }
}

const getCreditCardAlias = (card, format = true) => {
    let alias = ''

    if (card.methodDetails.creditCardNumberMasked) alias = card.methodDetails.creditCardNumberMasked

    if (format) return '.... .... .... ' + alias.slice(-4)
    return alias
}

export const CardHelper = {
    BrandOfCard,
    getCreditCardAlias
}